const state = {
  appName: "admin",

  stateValue: "abc",

  // 用户信息
  userInfo: null,
  
  // 菜单权限
  userMenu: null,
  
  // 消息中心未读消息数量
	noReadNums: 0,
};
export default state;
